import { RoutineListHeader } from "./routine-list/RoutineListHeader";
import { PlanModeToggle } from "./PlanModeToggle";
import { PlanMode } from "../hooks/usePlanMode";

interface WorkoutPlanHeaderProps {
  onBack: () => void;
  hideBackButton?: boolean;
  canEdit: boolean;
  planId: string;
  onAddRoutine: (routineId: string) => Promise<void>;
  mode: PlanMode;
  routines: any[];
}

export const WorkoutPlanHeader = ({
  onBack,
  hideBackButton,
  canEdit,
  planId,
  onAddRoutine,
  mode,
  routines,
}: WorkoutPlanHeaderProps) => {
  return (
    <div className="space-y-3">
      <RoutineListHeader 
        onBack={onBack} 
        hideBackButton={hideBackButton} 
        canEdit={canEdit} 
        planId={planId} 
        onAddRoutine={onAddRoutine} 
      />
      <div className="flex justify-end">
        <PlanModeToggle planId={planId} mode={mode} canEdit={canEdit} routines={routines} />
      </div>
    </div>
  );
};
